import { from } from 'apollo-link';
import onErrorLink from './onErrorLink';
import authLink from './authLink';
import uploadLink from './uploadLink';

const links = from([onErrorLink, authLink, uploadLink]);

export default links;
